import React from 'react';
import { View } from 'react-native';

import styles from './card-header.style';
import { useColors } from '../../../../hooks';

export function CardHeader({ children }) {
  const theme = useColors();
  return (
    <View style={[styles.header, { borderColor: theme.separatorOnBackground }]}>
      {children}
    </View>
  );
}
